/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as LoginImport } from './routes/login'
import { Route as ForgetPasswordImport } from './routes/forget-password'
import { Route as LayoutImport } from './routes/_layout'
import { Route as ExploreIndexImport } from './routes/explore/index'
import { Route as ForumForumIdImport } from './routes/forum.$forumId'
import { Route as LayoutProfileIndexImport } from './routes/_layout/profile/index'
import { Route as LayoutProductIndexImport } from './routes/_layout/product/index'
import { Route as LayoutMyProductIndexImport } from './routes/_layout/my-product/index'
import { Route as LayoutModuleIndexImport } from './routes/_layout/module/index'
import { Route as LayoutMeetingIndexImport } from './routes/_layout/meeting/index'
import { Route as LayoutForumIndexImport } from './routes/_layout/forum/index'
import { Route as LayoutEventIndexImport } from './routes/_layout/event/index'
import { Route as LayoutProductProductIdImport } from './routes/_layout/product/$productId'
import { Route as LayoutMyProductMutationImport } from './routes/_layout/my-product/mutation'
import { Route as LayoutMeetingMeetingIdImport } from './routes/_layout/meeting/$meetingId'
import { Route as LayoutEventEventIdImport } from './routes/_layout/event/$eventId'
import { Route as LayoutArticleArticleIdImport } from './routes/_layout/article/$articleId'
import { Route as LayoutArticleNewsIndexImport } from './routes/_layout/article/news/index'
import { Route as LayoutArticleKiatKiatIndexImport } from './routes/_layout/article/kiat-kiat/index'
import { Route as LayoutArticleCommunityIndexImport } from './routes/_layout/article/community/index'

// Create Virtual Routes

const RegisterLazyImport = createFileRoute('/register')()
const LayoutIndexLazyImport = createFileRoute('/_layout/')()
const LayoutContactUsIndexLazyImport = createFileRoute('/_layout/contact-us/')()

// Create/Update Routes

const RegisterLazyRoute = RegisterLazyImport.update({
  path: '/register',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/register.lazy').then((d) => d.Route))

const ResetPasswordRoute = ResetPasswordImport.update({
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const ForgetPasswordRoute = ForgetPasswordImport.update({
  path: '/forget-password',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexLazyRoute = LayoutIndexLazyImport.update({
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() => import('./routes/_layout/index.lazy').then((d) => d.Route))

const ExploreIndexRoute = ExploreIndexImport.update({
  path: '/explore/',
  getParentRoute: () => rootRoute,
} as any)

const ForumForumIdRoute = ForumForumIdImport.update({
  path: '/forum/$forumId',
  getParentRoute: () => rootRoute,
} as any)

const LayoutContactUsIndexLazyRoute = LayoutContactUsIndexLazyImport.update({
  path: '/contact-us/',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/contact-us/index.lazy').then((d) => d.Route),
)

const LayoutProfileIndexRoute = LayoutProfileIndexImport.update({
  path: '/profile/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutProductIndexRoute = LayoutProductIndexImport.update({
  path: '/product/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMyProductIndexRoute = LayoutMyProductIndexImport.update({
  path: '/my-product/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutModuleIndexRoute = LayoutModuleIndexImport.update({
  path: '/module/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMeetingIndexRoute = LayoutMeetingIndexImport.update({
  path: '/meeting/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutForumIndexRoute = LayoutForumIndexImport.update({
  path: '/forum/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutEventIndexRoute = LayoutEventIndexImport.update({
  path: '/event/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutProductProductIdRoute = LayoutProductProductIdImport.update({
  path: '/product/$productId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMyProductMutationRoute = LayoutMyProductMutationImport.update({
  path: '/my-product/mutation',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMeetingMeetingIdRoute = LayoutMeetingMeetingIdImport.update({
  path: '/meeting/$meetingId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutEventEventIdRoute = LayoutEventEventIdImport.update({
  path: '/event/$eventId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutArticleArticleIdRoute = LayoutArticleArticleIdImport.update({
  path: '/article/$articleId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutArticleNewsIndexRoute = LayoutArticleNewsIndexImport.update({
  path: '/article/news/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutArticleKiatKiatIndexRoute = LayoutArticleKiatKiatIndexImport.update(
  {
    path: '/article/kiat-kiat/',
    getParentRoute: () => LayoutRoute,
  } as any,
)

const LayoutArticleCommunityIndexRoute =
  LayoutArticleCommunityIndexImport.update({
    path: '/article/community/',
    getParentRoute: () => LayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/forget-password': {
      id: '/forget-password'
      path: '/forget-password'
      fullPath: '/forget-password'
      preLoaderRoute: typeof ForgetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterLazyImport
      parentRoute: typeof rootRoute
    }
    '/forum/$forumId': {
      id: '/forum/$forumId'
      path: '/forum/$forumId'
      fullPath: '/forum/$forumId'
      preLoaderRoute: typeof ForumForumIdImport
      parentRoute: typeof rootRoute
    }
    '/explore/': {
      id: '/explore/'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof ExploreIndexImport
      parentRoute: typeof rootRoute
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/article/$articleId': {
      id: '/_layout/article/$articleId'
      path: '/article/$articleId'
      fullPath: '/article/$articleId'
      preLoaderRoute: typeof LayoutArticleArticleIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/event/$eventId': {
      id: '/_layout/event/$eventId'
      path: '/event/$eventId'
      fullPath: '/event/$eventId'
      preLoaderRoute: typeof LayoutEventEventIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/meeting/$meetingId': {
      id: '/_layout/meeting/$meetingId'
      path: '/meeting/$meetingId'
      fullPath: '/meeting/$meetingId'
      preLoaderRoute: typeof LayoutMeetingMeetingIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/my-product/mutation': {
      id: '/_layout/my-product/mutation'
      path: '/my-product/mutation'
      fullPath: '/my-product/mutation'
      preLoaderRoute: typeof LayoutMyProductMutationImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/product/$productId': {
      id: '/_layout/product/$productId'
      path: '/product/$productId'
      fullPath: '/product/$productId'
      preLoaderRoute: typeof LayoutProductProductIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/event/': {
      id: '/_layout/event/'
      path: '/event'
      fullPath: '/event'
      preLoaderRoute: typeof LayoutEventIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/forum/': {
      id: '/_layout/forum/'
      path: '/forum'
      fullPath: '/forum'
      preLoaderRoute: typeof LayoutForumIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/meeting/': {
      id: '/_layout/meeting/'
      path: '/meeting'
      fullPath: '/meeting'
      preLoaderRoute: typeof LayoutMeetingIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/module/': {
      id: '/_layout/module/'
      path: '/module'
      fullPath: '/module'
      preLoaderRoute: typeof LayoutModuleIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/my-product/': {
      id: '/_layout/my-product/'
      path: '/my-product'
      fullPath: '/my-product'
      preLoaderRoute: typeof LayoutMyProductIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/product/': {
      id: '/_layout/product/'
      path: '/product'
      fullPath: '/product'
      preLoaderRoute: typeof LayoutProductIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/profile/': {
      id: '/_layout/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof LayoutProfileIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/contact-us/': {
      id: '/_layout/contact-us/'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof LayoutContactUsIndexLazyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/article/community/': {
      id: '/_layout/article/community/'
      path: '/article/community'
      fullPath: '/article/community'
      preLoaderRoute: typeof LayoutArticleCommunityIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/article/kiat-kiat/': {
      id: '/_layout/article/kiat-kiat/'
      path: '/article/kiat-kiat'
      fullPath: '/article/kiat-kiat'
      preLoaderRoute: typeof LayoutArticleKiatKiatIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/article/news/': {
      id: '/_layout/article/news/'
      path: '/article/news'
      fullPath: '/article/news'
      preLoaderRoute: typeof LayoutArticleNewsIndexImport
      parentRoute: typeof LayoutImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  LayoutRoute: LayoutRoute.addChildren({
    LayoutIndexLazyRoute,
    LayoutArticleArticleIdRoute,
    LayoutEventEventIdRoute,
    LayoutMeetingMeetingIdRoute,
    LayoutMyProductMutationRoute,
    LayoutProductProductIdRoute,
    LayoutEventIndexRoute,
    LayoutForumIndexRoute,
    LayoutMeetingIndexRoute,
    LayoutModuleIndexRoute,
    LayoutMyProductIndexRoute,
    LayoutProductIndexRoute,
    LayoutProfileIndexRoute,
    LayoutContactUsIndexLazyRoute,
    LayoutArticleCommunityIndexRoute,
    LayoutArticleKiatKiatIndexRoute,
    LayoutArticleNewsIndexRoute,
  }),
  ForgetPasswordRoute,
  LoginRoute,
  ResetPasswordRoute,
  RegisterLazyRoute,
  ForumForumIdRoute,
  ExploreIndexRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_layout",
        "/forget-password",
        "/login",
        "/reset-password",
        "/register",
        "/forum/$forumId",
        "/explore/"
      ]
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/",
        "/_layout/article/$articleId",
        "/_layout/event/$eventId",
        "/_layout/meeting/$meetingId",
        "/_layout/my-product/mutation",
        "/_layout/product/$productId",
        "/_layout/event/",
        "/_layout/forum/",
        "/_layout/meeting/",
        "/_layout/module/",
        "/_layout/my-product/",
        "/_layout/product/",
        "/_layout/profile/",
        "/_layout/contact-us/",
        "/_layout/article/community/",
        "/_layout/article/kiat-kiat/",
        "/_layout/article/news/"
      ]
    },
    "/forget-password": {
      "filePath": "forget-password.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/register": {
      "filePath": "register.lazy.tsx"
    },
    "/forum/$forumId": {
      "filePath": "forum.$forumId.tsx"
    },
    "/explore/": {
      "filePath": "explore/index.tsx"
    },
    "/_layout/": {
      "filePath": "_layout/index.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/article/$articleId": {
      "filePath": "_layout/article/$articleId.tsx",
      "parent": "/_layout"
    },
    "/_layout/event/$eventId": {
      "filePath": "_layout/event/$eventId.tsx",
      "parent": "/_layout"
    },
    "/_layout/meeting/$meetingId": {
      "filePath": "_layout/meeting/$meetingId.tsx",
      "parent": "/_layout"
    },
    "/_layout/my-product/mutation": {
      "filePath": "_layout/my-product/mutation.tsx",
      "parent": "/_layout"
    },
    "/_layout/product/$productId": {
      "filePath": "_layout/product/$productId.tsx",
      "parent": "/_layout"
    },
    "/_layout/event/": {
      "filePath": "_layout/event/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/forum/": {
      "filePath": "_layout/forum/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/meeting/": {
      "filePath": "_layout/meeting/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/module/": {
      "filePath": "_layout/module/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/my-product/": {
      "filePath": "_layout/my-product/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/product/": {
      "filePath": "_layout/product/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/profile/": {
      "filePath": "_layout/profile/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/contact-us/": {
      "filePath": "_layout/contact-us/index.lazy.tsx",
      "parent": "/_layout"
    },
    "/_layout/article/community/": {
      "filePath": "_layout/article/community/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/article/kiat-kiat/": {
      "filePath": "_layout/article/kiat-kiat/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/article/news/": {
      "filePath": "_layout/article/news/index.tsx",
      "parent": "/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
